import {
    GETTER_USER_UPLOADS_DOCUMENTS_TYPES,
} from "./types";


export default {
    [GETTER_USER_UPLOADS_DOCUMENTS_TYPES]: (state) => {
        return state.documentsTypes;
    },
};